/* Florida Tools – Mr. Tools welcome popup (port of approved preview v7). Theme-native, no app. */
(function () {
  'use strict';
  var root = document.getElementById('ftw-popup');
  if (!root || root.getAttribute('data-ftw-init')) return;
  root.setAttribute('data-ftw-init', '1');

  var K_SEEN = 'ftw_welcome_seen_v1', K_PEND = 'ftw_welcome_pending_v1';
  var design = root.getAttribute('data-design') === 'true';
  var delay = Math.max(0, parseFloat(root.getAttribute('data-delay')) || 2) * 1000;
  var card = root.querySelector('.ftw-card');
  var form = document.getElementById('ftw-form');
  var input = document.getElementById('ftw-email');
  var err = document.getElementById('ftw-error');
  var success = document.getElementById('ftw-success');
  var submit = form.querySelector('.ftw-submit');
  var doneBtn = root.querySelector('[data-ftw-done]');
  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var previousFocus = null, isOpen = false;

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }

  function loadAssets() {
    if (!document.getElementById('ftw-fonts')) {
      var l = document.createElement('link');
      l.id = 'ftw-fonts'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=DM+Sans:wght@400;500;600;700&display=swap';
      document.head.appendChild(l);
    }
    Array.prototype.forEach.call(root.querySelectorAll('image[data-ftw-src]'), function (img) {
      if (!img.getAttribute('href')) img.setAttribute('href', img.getAttribute('data-ftw-src'));
    });
  }

  /* ---- Speech bubble: text appears letter by letter (from approved preview) ---- */
  var speech = root.querySelector('.ftw-speech');
  var speechHeading = speech.querySelector('strong');
  var speechMessage = speech.querySelector('span');
  var speechText = [speechHeading.textContent, speechMessage.textContent];
  var speechFrame = 0;
  var speechLetters = [speechHeading, speechMessage].map(function (el, i) {
    el.textContent = '';
    return Array.from(speechText[i]).map(function (ch) {
      var s = document.createElement('span');
      s.className = 'ftw-letter';
      s.textContent = ch;
      el.appendChild(s);
      return s;
    });
  });
  speech.setAttribute('aria-label', speechText.join(' '));
  speechHeading.setAttribute('aria-hidden', 'true');
  speechMessage.setAttribute('aria-hidden', 'true');

  function stopSpeech() { cancelAnimationFrame(speechFrame); speech.classList.remove('ftw-talking'); }
  function startSpeech() {
    stopSpeech();
    var all = speechLetters[0].concat(speechLetters[1]);
    all.forEach(function (e) { e.classList.toggle('ftw-revealed', reduced.matches); });
    if (reduced.matches) return;
    var started = 0, firstDuration = speechLetters[0].length * 68, pause = 400, secondDuration = speechLetters[1].length * 61;
    function tick(now) {
      if (!started) started = now;
      var t = now - started - 1100;
      var phase = t < firstDuration ? 0 : 1;
      var local = phase === 0 ? t : t - firstDuration - pause;
      var speed = phase === 0 ? 68 : 61;
      var count = Math.max(0, Math.floor(local / speed) + 1);
      speechLetters[0].forEach(function (e, i) { e.classList.toggle('ftw-revealed', phase === 1 || i < count); });
      speechLetters[1].forEach(function (e, i) { e.classList.toggle('ftw-revealed', phase === 1 && i < count); });
      var phrase = speechText[phase];
      var current = phrase[Math.min(Math.max(count - 1, 0), phrase.length - 1)];
      var active = t >= 0 && local >= 0 && count <= phrase.length && !/[ ,.!?]/.test(current);
      speech.classList.toggle('ftw-talking', active);
      if (t < firstDuration + pause + secondDuration + 100) speechFrame = requestAnimationFrame(tick); else stopSpeech();
    }
    speechFrame = requestAnimationFrame(tick);
  }

  /* ---- Arm + hand: gentle wave around the elbow (from approved preview) ---- */
  var hand = document.getElementById('ftw-arm');
  var handFrame = 0;
  function stopHand() { cancelAnimationFrame(handFrame); hand.setAttribute('transform', 'rotate(0 815 975)'); }
  function startHand() {
    stopHand();
    if (reduced.matches) return;
    var start = 0;
    function move(now) {
      if (!start) start = now;
      var t = (now - start) % 4200;
      var wave = t < 2700 ? Math.sin(t / 260) * Math.sin(Math.PI * t / 2700) * 2.6 : 0;
      hand.setAttribute('transform', 'rotate(' + wave.toFixed(2) + ' 815 975)');
      handFrame = requestAnimationFrame(move);
    }
    handFrame = requestAnimationFrame(move);
  }
  if (reduced.addEventListener) reduced.addEventListener('change', function () { if (isOpen) { startSpeech(); startHand(); } });

  /* ---- Open / close ---- */
  function open() {
    if (isOpen) return;
    isOpen = true;
    loadAssets();
    if (!design) ls(K_SEEN, String(Date.now()));
    previousFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ftw-lock');
    if (root.getAnimations) root.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); a.play(); });
    startSpeech(); startHand();
    card.focus({ preventScroll: true });
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    stopSpeech(); stopHand();
    root.hidden = true;
    document.documentElement.classList.remove('ftw-lock');
    if (previousFocus && previousFocus !== document.body && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  root.addEventListener('click', function (e) {
    if (e.target === root || e.target.closest('[data-ftw-close]') || e.target.closest('[data-ftw-done]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = Array.prototype.filter.call(card.querySelectorAll('button,input:not([type=hidden]),a[href]'), function (el) { return el.getClientRects().length && !el.disabled; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === card || !card.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || a === card || !card.contains(a))) { e.preventDefault(); first.focus(); }
  });

  /* ---- Real signup (Shopify customer form, marketing consent) ---- */
  function setError(msg) {
    if (!msg) { err.hidden = true; err.textContent = ''; input.removeAttribute('aria-invalid'); input.setAttribute('aria-describedby', 'ftw-legal'); return; }
    err.textContent = msg; err.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', 'ftw-error ftw-legal');
  }
  function showSuccess(text) {
    ls(K_PEND, null);
    if (text) document.getElementById('ftw-success-text').textContent = text;
    form.hidden = true;
    success.hidden = false;
    card.setAttribute('aria-labelledby', 'ftw-success-title');
    doneBtn.focus({ preventScroll: true });
  }
  function busy(b) { submit.classList.toggle('is-busy', b); submit.setAttribute('aria-busy', b ? 'true' : 'false'); }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // Validate first (capture phase, before Shopify's bot-protection handler). A valid email is then
  // submitted natively so Shopify can attach its hCaptcha token; the result is shown after the reload.
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var v = (input.value || '').trim();
    input.value = v;
    if (!EMAIL_RE.test(v)) {
      e.preventDefault(); e.stopImmediatePropagation();
      setError('Please enter a valid email address.'); input.focus();
      return;
    }
    setError('');
    ls(K_PEND, '1');
    busy(true);
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) busy(false); });
  input.addEventListener('input', function () { if (!err.hidden) setError(''); });
  input.addEventListener('focus', function () {
    // keep the field visible above the mobile keyboard
    setTimeout(function () { try { input.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }, 350);
  });

  /* ---- When to show ---- */
  if (design) {
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    return;
  }
  if (/^\/challenge/.test(window.location.pathname)) return;   // Shopify bot-check page
  // Returning from a popup signup: show the real result from Shopify.
  if (ls(K_PEND) === '1') {
    var okEl = form.querySelector('[data-ftw-ok]');
    var errEl = form.querySelector('[data-ftw-server-error]');
    var posted = (window.location.search || '').indexOf('customer_posted=true') !== -1;
    if (okEl || errEl || posted) {
      ls(K_PEND, null);
      open();
      var txt = errEl ? (errEl.textContent || '').toLowerCase() : '';
      if (errEl && /taken|already|exist/.test(txt)) showSuccess('You’re already on our list. Thanks, partner! Watch your inbox for exclusive coupons and news from Florida Tools.');
      else if (errEl) { setError(txt ? 'Please check your email address and try again.' : 'Something went wrong. Please try again in a moment.'); }
      else showSuccess();
      return;
    }
    // Pending flag without a result (e.g. visitor left the bot-check page): clear it.
    ls(K_PEND, null);
  }
  if (ls(K_SEEN)) return;          // already shown once in this browser
  loadAssets();                    // fetch images while waiting
  setTimeout(open, delay);
})();
